import { h } from 'preact';
import { Badge } from '../Badge';
import type { ComponentShowcase } from '../registry';

export const showcase: ComponentShowcase = {
  name: 'Badge',
  category: '📊 Data Display',
  description: 'Badge com 5 variantes (success, warning, error, info, neutral) e dot indicator',
  usedIn: ['Integrations', 'AgentesPage', 'ReferralDashboard'],
  example: () => (
    <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
      <Badge variant="success">Ativo</Badge>
      <Badge variant="warning" dot>Pendente</Badge>
      <Badge variant="error">Erro</Badge>
      <Badge variant="info">Info</Badge>
      <Badge variant="neutral">Neutro</Badge>
    </div>
  ),
};
